const selector = "[data-events-view-switcher]";

let els = null;

function EventsViewSwitcher() {

	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Loop through each filters set
	[].forEach.call(els, function(item) {

		const trigger = item.querySelector("[data-events-view-switcher-trigger]");

		// Listen for any change events inside filters
		trigger.addEventListener("click", function(e) {

			// Prevent link going to url
			e.preventDefault();
			
			// Create custom event to pass up list of filter values
			const viewChangeClickEvent = new Event("view-change-click", {
				bubbles: true
			});

			// Dispatch custom event
			trigger.dispatchEvent(viewChangeClickEvent);
		});
	});
}

export default EventsViewSwitcher;